import { css } from '@eti/styles';
import { Notice, Text, textVariants } from '@etg/wings';
import { connect } from 'react-redux';
import { useProductData } from '../../common/hook/useProductData';
import NewSmallCardLayout from '../../common/components/small-card-layout/NewSmallCardLayout';
import { ProductCardLayoutType } from '../../common/models/product';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { CO2_COMPENSATION } from '../../products';
import { getSelected } from '../../single-choice/utils/selection';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CO2_COMPENSATION;
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT,
  PostBooking: POST_BOOKING_LAYOUT
} = ProductCardLayoutType;
const sharedTranslations = {
  title: 'co2CompensationTitle',
  persuasionContent: 'co2CompensationPersuasionContent',
  readMoreContent: 'co2CompensationReadMoreModalContent',
  promotionalText: 'co2CompensationPromotionalText'
};
const mainCardTranslations = {
  ...sharedTranslations,
  abstractContent: 'co2CompensationAbstract',
  additionalInformation: 'co2CompensationAdditionalSalesText',
  upSell: 'co2CompensationUpSellText'
};
const translations = {
  [MAIN_CARD_LAYOUT]: mainCardTranslations,
  [POST_BOOKING_LAYOUT]: mainCardTranslations,
  [SMALL_CARD_LAYOUT]: {
    ...sharedTranslations,
    abstractContent: 'co2CompensationAbstractSmallCard',
    upSell: 'co2CompensationUpSellTextSmallCard'
  }
};
const noticeStyles = css`
  margin-top: 8px;

  & svg {
    height: 16px;
    margin-block: auto;
    width: 16px;
  }
`;
const Co2Compensation = _ref => {
  let {
    className,
    form,
    isSelected,
    order,
    productPosition,
    layoutType = MAIN_CARD_LAYOUT
  } = _ref;
  const texts = translations[layoutType] || {};
  const {
    productData,
    rootElement,
    translation: {
      promotionalText
    }
  } = useProductData({
    className,
    form,
    isSelected,
    layoutType,
    order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    texts
  });
  if (!productData) {
    return null;
  }
  const PromotionalText = () => {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: promotionalText && /*#__PURE__*/_jsx(Notice, {
        className: noticeStyles,
        variant: "promotional",
        children: /*#__PURE__*/_jsx(Text, {
          asHtml: true,
          variant: textVariants._14_BOLD,
          children: promotionalText
        })
      })
    });
  };
  switch (layoutType) {
    case SMALL_CARD_LAYOUT:
      return /*#__PURE__*/_jsx(NewSmallCardLayout, {
        productData: productData,
        ref: rootElement,
        children: /*#__PURE__*/_jsx(NewSmallCardLayout.Body, {
          children: /*#__PURE__*/_jsx(PromotionalText, {})
        })
      });
    case MAIN_CARD_LAYOUT:
    default:
      return /*#__PURE__*/_jsx(ProductLayout, {
        productData: productData,
        ref: rootElement,
        children: /*#__PURE__*/_jsx(ProductLayout.Body, {
          children: /*#__PURE__*/_jsx(PromotionalText, {})
        })
      });
  }
};
const mapStateToProps = (state, _ref2) => {
  let {
    form
  } = _ref2;
  return {
    isSelected: getSelected(PRODUCT_NAME, form)(state)
  };
};
export default connect(mapStateToProps)(Co2Compensation);
//# sourceMappingURL=Co2Compensation.js.map